"use client";

/**
 * Background Calls Provider
 * Client component that renders the background call indicator
 */

import { useSetAtom } from "jotai";
import { BackgroundCallIndicator } from "@/frontend/features/agents/test-modal/components/BackgroundCallIndicator";
import { removeBackgroundCallAtom } from "@/frontend/lib/atoms/core/background-calls";

export function BackgroundCallsProvider() {
  const removeBackgroundCall = useSetAtom(removeBackgroundCallAtom);

  return <BackgroundCallIndicator onDismiss={removeBackgroundCall} />;
}
